import React, { useEffect, useState } from 'react';
import BaseDialog from './BaseDialog';
import constants from './constants';
import { useAuth } from './AuthProvider';

const portalNames = {
  [constants.PORTALS.ADMIN]: 'Admin Portal',
  [constants.PORTALS.DENTIST]: 'Dentist Portal',
  [constants.PORTALS.EMPLOYER]: 'Employer Portal',
  [constants.PORTALS.MEMBER]: 'Member Portal',
} as const;

type PortalKey = keyof typeof portalNames;

interface SignedOutDialogProps {
  portal: PortalKey;
}

export default function SignedOutDialog({ portal }: SignedOutDialogProps) {
  const { showSignedOutDialog, closeSignedOutDialog } = useAuth();
  const handleClose = () => {
    closeSignedOutDialog();
  };

  return (
    <BaseDialog
      id="sign-out"
      showCloseButton
      title="You have been signed out"
      open={showSignedOutDialog}
      onClose={handleClose}
      actions={{ 'Sign in again': handleClose }}
    >
      You have been signed out of Bento {portalNames[portal]}. Sessions in all tabs have been signed
      out.
    </BaseDialog>
  );
}
